export default __webpack_public_path__ + "static/media/video call.ecb1b6c8.png";